export default "__VITE_ASSET__DDiHl4xP__"